import { render } from "./SponsorsCards.vue?vue&type=template&id=0ed42322"
import script from "./SponsorsCards.vue?vue&type=script&lang=js"
export * from "./SponsorsCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__